import {Component, ElementRef, Inject, Input, OnDestroy, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {AppService} from "../app.service";
import {animate, group, state, style, transition, trigger} from '@angular/animations'
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {WorkerFilterOption} from "../app-settings";
import {PfUserResource} from "pfapi";
import {from, interval, Observable, Subject} from "rxjs";
import {debounce, map, shareReplay, startWith, switchMap, tap} from "rxjs/operators";

@Component({
    selector: 'app-workers',
    templateUrl: './workers.component.html',
    styleUrls: ['./workers.component.css'],
    animations: [
        trigger('workerState', [
            state('checkedIn', style({ opacity: 1, transform: 'translateX(0)' })),
            state('checkedOut', style({ opacity: 0, transform: 'translateX(-200%)' })),
            // transition('checkedOut => checkedIn', animate('0.3s ease-out')),
            transition('checkedOut => checkedIn', [
                animate('0.4s ease-out')
            ]),
            transition('checkedIn => checkedOut', [
                group([
                    animate('0.4s ease-in', style({
                        transform: 'rotateY(90deg) ',
                    })),
                    animate('0.4s 0.2s ease-in', style({
                        opacity: 0
                    })),
                ])
            ])
            // transition('checkedIn => checkedOut', [
            //   animate(2000, keyframes([
            //     style({transform: 'translate3d(0,0, 0)', offset: 0}),
            //     style({transform: 'translateY(20px) rotateX(20deg) ', offset: 0.10}),
            //     style({transform: 'translateY(50px) rotateX(50deg) rotateY(  18deg )', offset: 0.25}),
            //     style({transform: 'translateY(100px) rotateX(120deg) rotateY(  30deg )', offset: 0.45}),
            //     style({transform: 'translateY(290px) rotateX(280deg) rotateY(  50deg )', offset: 0.70}),
            //     style({transform: 'translate3d(0, 800px, 0) rotateX(520deg) rotateY(  40deg )', offset: 1}),
            //   ]))
            // ])
        ])
    ],
    standalone: false
})
export class WorkersComponent implements OnInit, OnDestroy {
  public visibleWorkers$: Observable<PfUserResource[]>;
  public activeTheme;
  public workerCount = 0;
  public overflowNumber = 0;
  public limit = 100;
  public columns = 6;

  private forceLayout = new Subject<void>();
  private resizeEventListener;

  @Input() showAbsent: boolean;
  @ViewChild('outerElement', {static: true}) outerElementRef: ElementRef;

  constructor(public appService: AppService, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.visibleWorkers$ = this.forceLayout.pipe(
      debounce(() => interval(150)),
      startWith(1),
      switchMap(() => this.appService.getAllWorkersObservable()),
      map(workers => workers
        .filter(worker =>
          !this.showAbsent && this.appService.isVisibleWorker(worker) ||
          this.showAbsent && this.getShowAbsent() && worker.apiData.absent)
        .sort((workerA, workerB) => {
          return workerA.apiData.checkedIn && !workerB.apiData.checkedIn ? -1
            : !workerA.apiData.checkedIn && workerB.apiData.checkedIn ? 1
            : 0;
          })
      ),
      tap(workers => {
        this.workerCount = workers.length;
        this.checkWorkerComponentChanges();
      }),
      map(workers => this.limit < this.workerCount ? workers.slice(0, this.limit) : workers),
      shareReplay(1)
    );

    this.activeTheme = this.appService.getColor();
    this.addEventListenerResize()
  }

  ngOnDestroy(): void {
    this.removeEventListenerResize();
  }

  getShowImageSetting(): boolean {
    return this.appService.getSettings().showImages;
  }

  getShowAbsent(): boolean {
    return this.appService.getSettings().showAbsent ;
  }

  public openWorkerList() {
    this.dialog.open(WorkerListDialog, {
      disableClose: false,
      data: {showAbsent: this.showAbsent}
    });
  }

  public getAnimationState(worker: PfUserResource) {
    return this.appService.getSettings().workerFilter == WorkerFilterOption.All || worker.apiData.absent ? "checkedIn" : worker.apiData["stateA"];
  }

  public getCICOTypeClass(worker: PfUserResource) {
    return worker.apiData.currentcicotyp || this.appService.getSettings().workerFilter != WorkerFilterOption.All ? "" : "checkedOut";
  }

  public openWorkerInfo(worker){
    this.appService.setResizeIsOk(false);        //Wenn wir aus dem Module conntent raus springen brauchen wir kein resize für worker grid mehr
    this.appService.setWorkerInfoWorker(worker);
    this.appService.clearInputFocusIntervalTimer();
    this.appService.getRouter().navigate(['/worker']);
    console.log("clicked worker", worker);
  }

  private checkWorkerComponentChanges() {
    let arrayChanged: boolean = false;
    let columnsChanged: boolean;

    // Wir ermitteln wieviele Spalten wir brauchen
    let columns = this.appService.getSettings().columnCount || 6;
    columnsChanged = columns != this.columns;

    let oneRow = this.outerElementRef.nativeElement.offsetWidth / columns;  // ist möglich, da Karreln quatratisch sind
    let height100 = window.innerHeight * 0.84; // Wir haben oben 9% und unten 7% Abstand

    // Wir brauchen ggf. eine Zeile für die Abwesenden
    if (this.appService.getSettings().showAbsent)
      height100 -= oneRow + 32 ;

    let rows: number = 1;
    if (!this.showAbsent) {
      for (let r = 10; r > 0; r--) {
        // wir ermitteln wie viele Kacheln max angezeigt werden können / wieviele Reihen wir brauchen
        if ((r * oneRow < height100) && arrayChanged == false) {
          arrayChanged = true;
          rows = r;
        }
      }
    }

    // Wenn der Platz sowieso reicht für alle Kacheln
    if (this.workerCount <= rows * columns) {
        this.columns = columns;
        this.limit = this.workerCount;
        this.overflowNumber = 0;
    } else {
      let lengthOneGrp = this.workerCount; // wir holen uns die Länge des aktuellen ersten Arrays
      if (columnsChanged || lengthOneGrp > rows * columns || lengthOneGrp <= (rows - 1) * columns) {  // Länge des Arrays überprüfen, ob es nötig ist die Arrays auf die entsprechende Länge an zu passen
        this.columns = columns;
        this.limit = rows * columns - 1;
        this.overflowNumber = this.workerCount - this.limit;
      }
    }
  }

  public showCiCoTypeIcon(): boolean {
    return this.appService.getSettings().workerFilter === WorkerFilterOption.All ||
      this.appService.getSettings().workerFilter === WorkerFilterOption.CheckedIn;
  }

  private addEventListenerResize() {
    this.resizeEventListener = window.addEventListener("resize", () => {
      this.forceLayout.next()
    });
  }

  private removeEventListenerResize() {
    window.removeEventListener("resize", this.resizeEventListener);
    this.resizeEventListener = null;
  }
}

@Component({
    selector: 'workerList-dialog',
    templateUrl: './workerList.dialog.html',
    styleUrls: ['./workerList.dialog.css'],
    standalone: false
})
export class WorkerListDialog implements OnInit{
  public activeTheme;
  public visibleWorkers$;
  private showAbsent: false;

  constructor(public appService: AppService, public dialogRef: MatDialogRef<WorkerListDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any) {
    this.activeTheme = this.appService.getColor();
    this.showAbsent = data.showAbsent;
  }


  ngOnInit(): void {
    this.visibleWorkers$ = this.appService.getAllWorkersObservable().pipe(
      switchMap(workers => from([workers
        .filter(worker =>
          this.showAbsent && worker.apiData.absent || !this.showAbsent && this.appService.isVisibleWorker(worker))
        ])
      ),
      shareReplay(1)
    );
  }
}

@Pipe({
    name: 'workerGridFilter',
    standalone: false
})
export class WorkerGridFilterPipe implements PipeTransform {
  transform(workers: Array<any>, toggle: boolean): Array<any> {
    return workers.filter(worker => toggle ? worker._apiData.absent : !worker._apiData.absent);
  }
}
